/**
 * LoginPage
 * Login page wrapper with navigation logic
 * Feature: User Management (002-user-management)
 */

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Login from '../components/Login';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  // Redirect if already authenticated — honour original intended destination if present
  useEffect(() => {
    if (isAuthenticated && user) {
      const savedRedirect = sessionStorage.getItem('auth_redirect');
      sessionStorage.removeItem('auth_redirect');
      const from = savedRedirect || location.state?.from;
      if (from && from !== '/login') {
        navigate(from, { replace: true });
      } else {
        // Default landing page for everyone (including admins/super-admins):
        // the Learning Day Agenda dashboard.
        navigate('/', { replace: true });
      }
    }
  }, [isAuthenticated, user, navigate, location.state]);

  const handleLoginSuccess = () => {
    // Navigation will be handled by useEffect after auth state updates
  };

  const handleLoginError = (error) => {
    console.error('Login error:', error);
  };

  return (
    <Login
      onSuccess={handleLoginSuccess}
      onError={handleLoginError}
    />
  );
};

export default LoginPage;
